import { BaseApi } from './base.api.js';

export class ExerciseEvaluationApi extends BaseApi {
    constructor(client) {
        super(client, '/exercise-evaluations');
    }
}
